import { Text, Button } from "../../../Components/Index";

export function LoadingState() {
  return (
    <div className="nt-state" data-testid="notifications-loading">
      <div className="nt-spinner" aria-hidden="true" />
      <Text position="center" color="gray">
        در حال بارگذاری اعلان‌ها...
      </Text>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div
      className="nt-state nt-state--error"
      data-testid="notifications-error"
    >
      <Text position="center" color="red">
        {message}
      </Text>
      <Button size="mini" color="dark" onClick={onRetry}>
        تلاش مجدد
      </Button>
    </div>
  );
}

export function EmptyState() {
  return (
    <div className="nt-state" data-testid="notifications-empty">
      <Text position="center" FontSize="md">
        پیامی ثبت نشده
      </Text>
    </div>
  );
}
